export default "__VITE_ASSET__TSsQWWQB__"